<template lang="pug">
  .p-timefield(:class="containerClass" :style="containerStyle")
    PTextFieldLegado.p-timefield__hour(
      v-bind="localAttributes"
      type="text",
      :label="label"
      v-model="textInputComputed",
      autocomplete="disabled"
      v-mask="'##:##'",
      placeholder="00:00",
      :loading="loading",
      :disabled="disabled",
      v-on="localListeners",
      @focus="($event) => $event.target.select()"
      :error="error"
      :required="required"
    )

    PCheckbox(label="+1d", v-if="showPlusOneDay" v-model="plusOneDay", :disabled="disabled")

</template>

<script>
import { mask } from 'src/common/mask'
import moment from 'moment'

import PTextFieldLegado from './PTextFieldLegado.vue'
import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import {
  extrairAtributosDeControle,
  extrairClasseDoContainer,
  extrairEstiloDoContainer,
  extrairListenersDosAttrs
} from '../mixins/localListenersAndAttributes'
import {
  formatString24Hours
} from 'src/utils'
import { verificarSeHorarioInputValido } from 'src/utils/validadoras/validadoras'
import { converterHorarioParaObjetoMoment } from 'src/utils/formatadoras/formatadoras'

export default {
  name: 'PTimeField',
  inheritAttrs: false,
  emits: ['update:modelValue', 'change'],
  props: {
    label: {type: String, required: true},
    baseDate: {type: Date, required: true},
    showPlusOneDay: {type: Boolean, default: false},
    loading: Boolean,
    disabled: Boolean,
    error: {type: String, default: ''},
    format24Hours: { type: Boolean, default: false },
    required: {type: Boolean, required: false, default: false}
  },
  data () {
    return {
      textInput: '',
      internalPlusOneDay: false
    }
  },
  created () {
    if (moment(this.state).date() > moment(this.baseDate).date()) {
      this.internalPlusOneDay = true
    }

    this.textInput = moment(this.state).format('HH:mm')
  },
  computed: {
    plusOneDay: {
      set (newValue) {
        const baseDayOfMonth = moment(this.baseDate).date()
        const stateDayOfMonth = moment(this.state).date()

        if (newValue && (!this.state || !stateDayOfMonth)) {
          return;
        }

        this.internalPlusOneDay = newValue

        if (newValue) {
          this.state = baseDayOfMonth === stateDayOfMonth
            ? moment(this.state).add(1, 'days').toDate()
            : moment(this.state).toDate()
        } else {
          if (!this.state) return;
          this.state = baseDayOfMonth === stateDayOfMonth
            ? moment(this.state).toDate()
            : moment(this.state).subtract(1, 'days').toDate()
        }
      },
      get () {
        return this.internalPlusOneDay
      }
    },
    textInputComputed: {
      get () {
        return this.textInput
      },
      set (val) {
        this.textInput = val
        if (this.valid) {
          const time = converterHorarioParaObjetoMoment(val)
          const mergedDates = moment(this.baseDate).set({hour: time.hours(), minute: time.minutes(), seconds: 0})
          this.state = (this.plusOneDay ? mergedDates.add(1, 'days') : mergedDates).toDate()
        } else {
          if (this.textInput.length < 5) this.state = null
          if (this.format24Hours && this.textInput.length === 5) {
            this.textInput = formatString24Hours(this.textInput)
          }
        }
      }
    },
    valid () {
      return verificarSeHorarioInputValido(this.textInput, true)
    },
    containerClass () {
      return extrairClasseDoContainer(this.$attrs)
    },
    containerStyle () {
      return extrairEstiloDoContainer(this.$attrs)
    },
    localListeners () {
      return extrairListenersDosAttrs(this.$attrs)
    },
    localAttributes () {
      return extrairAtributosDeControle(this.$attrs, ['disabled'])
    }
  },
  watch: {
    baseDate: function (newValue, oldValue) {
      if (moment(newValue).diff(oldValue, 'hours') < 1) return
      if (this.valid) {
        const time = converterHorarioParaObjetoMoment(this.textInput)
        const mergedDates = moment(newValue).set({hour: time.hours(), minute: time.minutes()})
        this.state = (this.plusOneDay ? mergedDates.add(1, 'days') : mergedDates).toDate()
      }
    },
    state: function () {
      this.internalPlusOneDay = moment(this.state).date() > moment(this.baseDate).date()
      if (this.state) {
        this.textInput = moment(this.state).format('HH:mm')
      } else {
        this.textInput = ''
      }
    }
  },
  mixins: [handlerUseStateVmodel()],
  directives: { mask },
  components: { PTextFieldLegado }
}
</script>

<style scoped>
.p-timefield {
  display: flex;
  align-items: center;
}
</style>
